import React, { useEffect, useState } from "react";
import "../../components/DashboardModule/MyOrder.css";
import { MoreVertical } from "lucide-react";
import { getSellerMyCompleteOrder } from "../../API/Api";

const CompletedOrderSeller = () => {
	const [orders, setOrders] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchCompletedOrders = async () => {
			try {
				const response = await getSellerMyCompleteOrder();
				console.log('Response123:', response);
				if (response.status && response.data) {
					setOrders(response.data);
				}
			} catch (err) {
				setError(err.message || "Failed to fetch completed orders");
			} finally {
				setLoading(false);
			}
		};

		fetchCompletedOrders();
	}, []);


	if (loading) {
		return <div className="quo-container font-poppins">Loading...</div>;
	}

	if (error) {
		return <div className="quo-container font-poppins">Error: {error}</div>;
	}

	return (
		<div className="quo-container font-poppins">
			<div className="quo-header">
				<h2 className="quo-title">Completed Orders</h2>
			</div>

			<table className="quo-table">
				<thead>
					<tr>
						<th>Order Id</th>
						<th>Product Details</th>
						<th>Date</th>
						<th>Status</th>
						<th>Payment Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					{orders.map((order) => (
						<tr key={order.order_id}>
							<td>{order.order_id}</td>
							<td>
								{order.product_details?.product_name || "N/A"}
							</td>
							<td>
								{new Date(order.product_details?.created_at).toLocaleDateString()}
							</td>
							<td>{order.tracking_status || "Completed"}</td>
							<td>{order.payment_status || "Paid"}</td>
							<td>
								{/* <div className="quo-action-menu">
									<button className="text-quo font-poppins">Add comment</button>
									<button className="text-quo font-poppins">Download</button>
									<button className="text-quo font-poppins">Cancel</button>
								</div>  <MoreVertical /> */}
								{/* <div className="quo-dropdown">
									<button className="text-quo font-poppins">Preview</button>

								</div> */}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default CompletedOrderSeller;
